import { HttpRequestEntity } from 'shared/domain/httpRequest/httpRequestModel';
import { chooseErrorMessage } from 'shared/utils/errorHandling';
import {
  broadcastUploadedVisibleFieldError,
  broadcastUploadedVisibleField,
} from 'serviceWorker/broadcasts/visibleFields';

export function broadcastVisibleFieldResponse(
  request: HttpRequestEntity,
  response: any
): void {
  if (response.error) {
    return broadcastUploadedVisibleFieldError(
      response.error,
      chooseErrorMessage(response.error),
      request.data.uniqueId
    );
  }

  return broadcastUploadedVisibleField(response, request.data.uniqueId);
}
